import api from '../api'
import { saveAs } from 'utils/saveAs'

function buildQueryString({ page, perPage, userId, fromDate, toDate }) {
	const params = new URLSearchParams()
	if (page) params.set('page', page)
	if (perPage) params.set('per_page', perPage)
	if (userId) params.set('user_id', userId)
	if (fromDate) params.set('from_date', fromDate)
	if (toDate) params.set('to_date', toDate)
	return params.toString()
}

export async function getAccessLogs({ page, perPage, userId, fromDate, toDate }) {
	const queryString = buildQueryString({ page, perPage, userId, fromDate, toDate })
	const { data } = await api.get(`/access-logs?${queryString}`)

	return data
}

export async function getDocumentLogs({ page, perPage, userId, fromDate, toDate }) {
	const queryString = buildQueryString({ page, perPage, userId, fromDate, toDate })
	const { data } = await api.get(`/documents/logs?${queryString}`)

	return data
}

export async function getUsersOptions(search = '') {
	const { data } = await api.get('/users', { params: { search, per_page: 100 } })

	return data.users.map((user) => ({ value: user.id, label: user.name }))
}

export async function exportAccessLogs({ userId, fromDate, toDate }) {
	const queryString = buildQueryString({ userId, fromDate, toDate })
	const response = await api.get(`/access-logs/export?${queryString}`, {
		responseType: 'blob',
	})

	const filename = `logs_acesso_${new Date().toISOString().slice(0, 10)}.xlsx`
	saveAs(response.data, filename)
}

export async function exportDocumentLogs({ userId, fromDate, toDate }) {
	const queryString = buildQueryString({ userId, fromDate, toDate })
	const response = await api.get(`/documents/logs/export?${queryString}`, {
		responseType: 'blob',
	})

	const filename = `logs_acoes_${new Date().toISOString().slice(0, 10)}.xlsx`
	saveAs(response.data, filename)
}
